import './cookies.less'

import {m, wrap} from '@codeurs/front'
import {Component, Fragment} from 'react'
import {BlocksData, PageData} from 'types'
import {style} from 'util/style'
import {Blocks} from 'views/blocks/blocks'
import {Hero} from 'views/partials/hero'
import {Newsletter} from 'views/partials/newsletter'
import {Theme} from 'views/theme'
import {Layout} from '../layout'

const styles = style('cookies')

@wrap(Layout)
export class Cookies extends Component<{
  data: PageData & BlocksData
}> {
  render() {
    const {id, title, blocks, newsletter, language} = this.props.data

    return (
      <Fragment>
        <div class={styles}>
          <Hero class={styles('hero')} hero={false}>
            <Theme.H1>{title}</Theme.H1>
          </Hero>
          <Theme.Container>
            <Blocks blocks={blocks} pageId={id} class={styles('blocks')} />
          </Theme.Container>
        </div>
        <Newsletter {...newsletter} language={language} />
      </Fragment>
    )
  }
}
